// ----------- set export Component
export const setRow = (row?: boolean) => {
  const items = { row: { flexDirection: 'row' }, column: {} };

  // ----------- set return
  return row ? items.row : items.column;
};
